<template>
  <div>
    <div class="textBox">
      <transition name="slide">
        <p
          class="text"
          :key="text.id"
          @mouseenter="mouseenter"
          @mouseleave="mouseleave"
        >
          {{ text.val }}
        </p>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "scroll",
  data() {
    return {
      textArr: ["WoYou工资依托人工智能技术为您提供更好服务"],
      number: 0,
      timer: null,
    };
  },
  computed: {
    text() {
      return {
        id: this.number,
        val: this.textArr[this.number],
      };
    },
  },
  mounted() {
    this.startMove();
  },
  methods: {
    mouseenter() {
      clearInterval(this.timer);
    },
    mouseleave() {
      this.startMove();
    },
    startMove() {
      this.timer = setTimeout(() => {
        if (this.number === 2) {
          this.number = 0;
        } else {
          this.number += 1;
        }
        this.startMove();
      }, 4000); // 滚动不需要停顿则将2000改成动画持续时间
    },
  },
};
</script>

<style scoped>
h2 {
  padding: 20px 0;
}
.textBox {
  width: 100%;
  height: 37px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  text-align: left;
}
.text {
  width: 100%;
  position: absolute;
  /* bottom: 10px; */
  font-size: 15px;
  height: 100%;
  line-height: 37px;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s linear;
}
.slide-enter {
  transform: translateY(20px) scale(1);
  opacity: 1;
}
.slide-leave-to {
  transform: translateY(-20px) scale(0.8);
  opacity: 0;
}
</style>